import { Component, OnInit, AfterViewInit, ElementRef, ViewChildren } from '@angular/core';
import { Login } from 'src/app/_models/login';
import { FormGroup, FormBuilder, Validators, FormControlName } from '@angular/forms';
import { GenericValidator } from 'src/app/_classes/generic.form.validator';
import { Router } from '@angular/router';
import { LoadingService } from 'src/app/_services/local/loading.service';
import { ToasterService } from 'angular2-toaster';
import { AuthenticationService } from 'src/app/_services/local/authentication.service';
import { AccontService } from 'src/app/_services/madu-api/accont.service';
import { UserInfos } from 'src/app/_models/user.infos';
import { User } from 'src/app/_models/user';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
  @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];

  private loginModel: Login;
  private validationMessages: { [key: string]: { [key: string]: string } };
  private genericValidator: GenericValidator;

  errors: any = [];
  recuperarSenhaOn: boolean = false;

  loginForm: FormGroup;
  displayMessage: { [key: string]: string } = {};

  constructor(private fb: FormBuilder,
    private router: Router,
    private loadingService: LoadingService,
    private authenticationService: AuthenticationService,
    private toasterService: ToasterService,
    private accountService: AccontService) {

    // redirect to home if already logged in
    if (this.authenticationService.currentUserValue) {
      this.router.navigate(['/']);
    }

    this.validationMessages = {
      email: {
        required: 'Informe o e-mail',
        email: 'Email invalido'
      },
      password: {
        required: 'Informe a senha',
        minlength: 'A senha deve possuir no mínimo 6 caracteres'
      }
    };

    this.genericValidator = new GenericValidator(this.validationMessages);
  }

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: '',
      code: ''
    });
  }

  onSubmit() {
    if (this.recuperarSenhaOn)
      this.resetarPassWord();
    else
      this.login();
  }

  login() {
    this.displayMessage = this.genericValidator.processMessages(this.loginForm);
    if (this.loginForm.dirty && this.loginForm.valid) {
      let login = this.loginForm.value;
      this.loadingService.showLoading(true);
      this.accountService.login(login).subscribe(
        apiRet => {
          this.loginOK(apiRet)
        },
        error => {
          this.loadingService.clearShowLoading();
          this.toasterService.pop('error', '-_-', 'Usuário ou senha errado!');
          this.ErroAPI(error);
        });
    }
  }

  private ErroAPI(error: any) {    
    console.log(error);
    if (error.errors != null) {
      this.errors = error.errors;            
    }       
  }

  private loginOK(res: UserInfos) {
    this.errors = [];
    if (res.success) {
      this.loadingService.clearShowLoading();
      this.authenticationService.login(res);
      this.toasterService.pop('success', 'Tudo OK :)', 'Seja bem vindo(a) ao Etiqueta Fácil!');
      this.router.navigate(['/']);
    }
    else {
      this.loadingService.clearShowLoading();
      this.toasterService.pop('warning', 'Atenção', 'Usuário não autorizado!');
    }
  }

  esqueciMinhaSenha() {
    if (this.loginForm.get('email').value == "") {
      this.toasterService.pop('info', 'Opa :|', 'Preencha o e-mail...');
      return;
    }
    this.loadingService.showLoading(true);

    this.accountService.forgotPassword(this.loginForm.get('email').value).subscribe(
      apiRet => {
        this.loadingService.clearShowLoading();
        this.errors = [];
        this.toasterService.pop('success', 'Tudo OK :)', 'Um e-mail será enviado para vocês com um código. Use-o nessa página.');
        this.recuperarSenhaOn = true;
      },
      error => {
        this.loadingService.clearShowLoading();
        this.toasterService.pop('error', '-_-', 'Não foi possível recuperar a senha.');
        this.ErroAPI(error);
      });
  }

  resetarPassWord() {

    this.displayMessage = this.genericValidator.processMessages(this.loginForm);
    if (this.loginForm.dirty && this.loginForm.valid) {
      let login = this.loginForm.value;

      if (login.password != login.confirmPassword) {
        this.loadingService.clearShowLoading();
        this.toasterService.pop('info', 'Opa :|', 'As senhas não são iguais');
        return;
      }

      this.loadingService.showLoading(true);

      this.accountService.resetPassword(login).subscribe(
        apiRet => {
          this.loadingService.clearShowLoading();
          this.errors = [];
          this.recuperarSenhaOn = false;
          this.login();
        },
        error => {
          this.loadingService.clearShowLoading();
          this.toasterService.pop('error', '-_-', 'Não foi possível trocar a senha.');
          this.ErroAPI(error);
        });
    }
  }

}